import React from 'react';

import { TextPropTypes } from 'deprecated-react-native-prop-types';
import PropTypes from 'prop-types';

import { VFText } from '@vfgroup-oneplatform/foundation/Components';

import styles from './PlanCardHeader.Styles';

function PlanCardHeader({ subTitle, subTitlePlaceholders, subTitleTextStyle, testKey, ...props }) {
  return (
    <>
      {subTitle && (
        <VFText
          i18nKey={subTitle}
          placeHolders={subTitlePlaceholders}
          style={[styles.subTitleTextStyle, subTitleTextStyle]}
          {...props}
        />
      )}
    </>
  );
}

PlanCardHeader.propTypes = {
  subTitle: PropTypes.string.isRequired,
  subTitlePlaceholders: PropTypes.arrayOf(PropTypes.string),
  subTitleTextStyle: TextPropTypes.style,
  testKey: PropTypes.string,
};

export default PlanCardHeader;
